<template>
  <transition type="animation" appear enter-active-class="animate__animated animate__fadeIn" mode="out-in">
    <div v-if="temPermissao('p-super-admin')" class="admin-superpro">
      <div class="mb-2 p-2 border-bottom border-light">
        <h5 class="font-weight-light">
          <span><i class="fa-light fa-school fa-lg"></i></span>
          Lista de Escolas
        </h5>
      </div>
      <b-form @submit.prevent="submitForm">
        <b-form-row>
          <b-col cols="12" md="6" lg="4" class="mt-4 mt-lg-3 form-group">
            <label for="input-idUser">CNPJ: <span class="text-danger">*</span></label>
            <b-input-group>
              <b-form-input size="sm" type="text" v-model.trim="form.cnpj" required></b-form-input>
              <b-input-group-append class="append">
                <i class="fa-regular fa-school"></i>
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col cols="12" md="6" lg="4" class="mt-4 mt-lg-3 form-group">
            <label for="input-idUser">Nome: <span class="text-danger">*</span></label>
            <b-input-group>
              <b-form-input size="sm" type="text" v-model.trim="form.nome" required></b-form-input>
              <b-input-group-append class="append">
                <i class="fa-regular fa-user"></i>
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col cols="12" md="6" lg="4" class="mt-lg-3 form-group">
            <label for="input-idUser">E-mail: <span class="text-danger">*</span></label>
            <b-input-group>
              <b-form-input size="sm" type="text" v-model.trim="form.email" required></b-form-input>
              <b-input-group-append class="append">
                <i class="fa-regular fa-envelope"></i>
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col cols="12" md="6" lg="4" class="form-group">
            <label for="input-idUser">Login: <span class="text-danger">*</span></label>
            <b-input-group>
              <b-form-input size="sm" type="text" v-model.trim="form.login" required></b-form-input>
              <b-input-group-append class="append">
                <i class="fa-regular fa-user"></i>
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col cols="12" md="6" lg="4" class="form-group">
            <label for="input-idUser">Senha: <span class="text-danger">*</span></label>
            <b-input-group>
              <b-form-input size="sm" :type="typeInput" v-model.trim="form.senha" required></b-form-input>
              <b-input-group-append @click="showPassword" class="append">
                <i :class="typeInput === 'password' ? 'fa-regular fa-eye icon' : 'fa-regular fa-eye-slash icon'"></i>
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col cols="12" md="6" lg="4" class="form-group">
            <label for="input-idUser">Prefixo: <span class="text-danger">*</span></label>
            <b-input-group>
              <b-form-input size="sm" :type="typeInput" v-model.trim="form.prefixo" required></b-form-input>
              <b-input-group-append class="append">
               <i class="fa-brands fa-autoprefixer"></i>
              </b-input-group-append>
            </b-input-group>
          </b-col>


          <b-col cols="12" md="2" lg="2" class="form-group">
            <label for="input-idUser">DDD: <span class="text-danger">*</span></label>
            <b-input-group>
              <b-form-input size="sm" :type="typeInput" v-model.trim="form.ddd" required></b-form-input>
              <b-input-group-append class="append">
                <i class="fa-regular fa-phone"></i>
              </b-input-group-append>
            </b-input-group>
          </b-col>


          <b-col cols="12" md="6" lg="4" class="form-group">
            <label for="input-idUser">Telefone/Celular: <span class="text-danger">*</span></label>
            <b-input-group>
              <b-form-input size="sm" :type="typeInput" v-model.trim="form.telefone" required></b-form-input>
              <b-input-group-append class="append">
                <i class="fa-regular fa-phone"></i>
              </b-input-group-append>
            </b-input-group>
          </b-col>

 


          <b-col cols="12" md="6" class="d-inline-flex align-items-center">
            <b-button class="shadow-none btn-primary border-primary w-auto" @click="postData()">Cadastrar</b-button>
          </b-col>
        </b-form-row>
      </b-form>

      <!-- AQUI PRECISA PERCORRER O ARRAY CADASTROESCOLA PARA INFORMAR AO USUÁRIO QUANDO FOR SUCESSO O CADASTRO E O ERRO QUANDO ESTIVER ERRADO  -->
      <b-row>
        <b-col cols="12" v-if="cadastraEscola.length != 0">
          <div v-if="cadastraEscola.erro === 0">
            <b-alert variant="success" show>
              <div class="row">
                <div class="col-2 text-center"><i class="fa-duotone fa-thumbs-up fa-3x"></i></div>
                <div class="col-10 text-left mt-2">
                  <span class="ajusteRetCriaUser">{{
                    'Usuário criado com sucesso ID: ' + cadastraEscola.idUsuario
                    }}</span>
                </div>
              </div>
            </b-alert>
          </div>
          <div v-else>
            <b-alert variant="danger" show>
              <div class="row">
                <div class="col-2 text-center"><i class="fa-duotone fa-thumbs-down fa-3x"></i></div>
                <div class="col-10 text-left mt-2">
                  <span class="ajusteRetCriaUser">{{ 'Erro: ' + cadastraEscola.erro }} &nbsp;{{ cadastraEscola.msg
                    }}</span>
                </div>
              </div>
            </b-alert>
          </div>
        </b-col>
      </b-row>
    </div>
    <div v-else>
      <div class="container">
        <div class="text-center">
          {{ error503 }}
          <p>Você não tem permissão para visualizar este conteúdo.</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import ApiService from '../../../../../common/api.service';

export default {
  data() {
    return {
      cadastraEscola: [],
      form: {
        cnpj: '',
        nome: '',
        email: '',
        login: '',
        senha: '',
        prefixo: '',
        ddd: '',
        telefone: '',
      },

      typeInput: '',
    };
  },

  created() {
    this.showPassword();
  },

  computed: {
    permissions() {
      return this.$store.state.auth.userpermissions.permissions;
    },
    error503() {
      return (window.location.href = '/nao-autorizado');
    },
  },

  methods: {
    temPermissao(permissao) {
      return this.permissions.includes(permissao);
    },

    async postData() {
      await ApiService.post('v1/criar-escolas', {
        cnpj: this.form.cnpj,
        nome: this.form.nome,
        email: this.form.email,
        login: this.form.login,
        senha: this.form.senha,
        prefixo: this.form.prefixo,
        ddd: this.form.ddd,
        telefone: this.form.telefone,
      })
        .then((response) => {
          this.cadastraEscola = response;
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => { });
    },

    showPassword() {
      this.typeInput = this.typeInput === 'password' ? 'text' : 'password'
    },
  },
};
</script>

<style scoped>
.fade-in-up {
  -webkit-animation: fadeIn 0.4s ease-in-out;
  -moz-animation: fadeIn 0.4s ease-in-out;
  -o-animation: fadeIn 0.4s ease-in-out;
  animation: fadeIn 0.4s ease-in-out;
}

.loading {
  height: 25vh;

  
}

.append i {
 
  vertical-align: middle;
  padding: 0.5rem;
  background-color:  #E9ECEF;
  color: fff;
}
</style>
